module.exports = __webpack_public_path__ + "img/chapter-1-thumb.71ba4767.jpg";